var _rect, _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconExames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#CFE7FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9994,
    cy: 25.0006,
    r: 1.50063,
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9994 26.5V28.5008C20.9994 30.7109 22.791 32.5025 25.0011 32.5025V32.5025C27.2111 32.5025 29.0027 30.7109 29.0027 28.5008V27.5004",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0018 20.498H26.5016C25.9491 20.498 25.5012 20.9459 25.5012 21.4985V23.9995C25.5012 25.9333 27.0689 27.501 29.0027 27.501V27.501C30.9365 27.501 32.5041 25.9333 32.5041 23.9995V21.4985C32.5041 20.9459 32.0562 20.498 31.5037 20.498H31.0035",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5037 17.4976V16.9973C31.5037 15.3398 30.16 13.9961 28.5025 13.9961H16.4975C14.8399 13.9961 13.4962 15.3398 13.4962 16.9973V27.5017C13.4962 29.1593 14.8399 30.503 16.4975 30.503H17.9981",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9981 12.4941V15.4954",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0019 12.4941V15.4954",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExames);
export default __webpack_public_path__ + "static/media/iconExames.1c37fa867a314404e45f0cdca78fcee9.svg";
export { ForwardRef as ReactComponent };